var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tryingConnection)?_c('GmapInfoWindow',{staticClass:"multiple-video-container",attrs:{"options":{
          pixelOffset: { width: 0, height: -15 }
        }}},[(_vm.socket && _vm.inProgress)?_c('VideoElementMultiple',{attrs:{"remoteCalledStream":_vm.remoteCalledStream,"loadingRemote":_vm.loadingRemote,"timerConnectionInterval":_vm.timerConnectionInterval,"closePreview":_vm.closePreview,"startVideoCall":_vm.goToFullVideoCall,"videoCallData":_vm.videoCallData}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }